export class ApplicantDetailChanged {
    constructor(item: ChangedItem, applicationId: number, extraId?: number) {
        this.changedItem = item;
        this.applicationId = applicationId;
        this.extraId = extraId;
    }
    applicationId: number;
    applicantId?: number;
    extraId?: number;
    changedItem: ChangedItem;
}

export enum ChangedItem {
    All,
    ApplicantRemovedFromInterviewerList,
    Interview,
    Issue,
    Uploads,
    ApplicationSubmittedToOffice,
    PoliceCheck,
    Visa,
    DS2019,
    MedicalForm,
    Reference,
    ReviewChecklist,
    Comment
}
